import React from 'react';

function PageDisabled(props) {
    return (
        <div className="w-full h-full flex flex-column gap-2 align-items-center justify-content-center">
            <h1 className="english-font text-8xl m-0">DISABLED</h1>
            {/*<span className="text-4xl">Page Not Found</span>*/}
            <span className="text-4xl">صفحه مورد نظر غیرفعال شده است</span>
        </div>
    );
}

export default PageDisabled;